import { Directive } from '@angular/core';

/**
 * @ignore
 */
@Directive({ selector: 'title-template' })
export class TitleTemplateDirective {
    constructor() { }
}